.css-performing-assets table thead,
.css-performing-assets table tbody {
  border-top: none !important;
  border-bottom: none !important;
}

.css-performing-assets table {
  border-collapse: collapse;
}

/* Hide "name" column */
.css-performing-assets table th:first-child {
  visibility:hidden
}
